var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h3',{staticClass:"mt-3",attrs:{"id":"table_5"}},[_vm._v(" Netverzwaringen ")]),_c('TableManager',{ref:"TableManager",staticClass:"RVBChargingpointCount",attrs:{"loading":_vm.loading,"source-records":_vm.RecordsWithGridUpgrade,"category":"rvb-customer-reporting","uuid":"079c2131-92dd-4371-80e3-7f6fb09cc9da"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }